/**
 * External Imports
 */
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAnalyticsApi } from '@shared-web-analytics/react';

/**
 * Internal Imports
 */
import { openModal, setModalType } from '../../../redux/actions';

import { logListClick } from '../../../utils/analyticsHelpers';

/**
 * Style Imports
 */
import { StyledSearchEmployeesBtn } from './SearchEmployeesBtn.styles';

const SearchEmployeesBtn: FC<{}> = () => {
  const dispatch = useDispatch();

  const { logTrackingEvent } = useAnalyticsApi();

  const { '*': view } = useParams();

  const roundUnlistedEmployee = () => {
    logTrackingEvent(logListClick('search-all', view));
    dispatch(setModalType('UnlistedEmployeeRound'));
    dispatch(openModal());
  };

  return (
    <StyledSearchEmployeesBtn
      id="Search-Employees-Button"
      color="blue"
      kind="primary"
      size="small"
      style={{ fontSize: '1rem', marginRight: '10px' }}
      onClick={roundUnlistedEmployee}
    >
      Search All Employees
    </StyledSearchEmployeesBtn>
  );
};

export default SearchEmployeesBtn;
